"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AugurysFinalOmenAbilityHandler = exports.AugurysFinalOmenActorAbilityFactory = exports.AugurysFinalOmenAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Bleeding_1 = require("../../core/effects/core/Bleeding");
const EffectType_1 = require("../../core/effects/EffectType");
const Registries_1 = require("../../core/state/Registries");
class AugurysFinalOmenAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.AugurysFinalOmen;
        this.__typeName = "AugurysFinalOmen";
    }
}
exports.AugurysFinalOmenAbilityArgs = AugurysFinalOmenAbilityArgs;
let AugurysFinalOmenActorAbilityFactory = class AugurysFinalOmenActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("AugurysFinalOmen", "OneEnemies", 4);
    }
};
AugurysFinalOmenActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("AugurysFinalOmen")
], AugurysFinalOmenActorAbilityFactory);
exports.AugurysFinalOmenActorAbilityFactory = AugurysFinalOmenActorAbilityFactory;
let AugurysFinalOmenAbilityHandler = class AugurysFinalOmenAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const invokerLevel = container.getLevel(ability.invokerId);
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "ranged",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Death", 180
                    + (container.hasEffectOfType(selectedEnemy, EffectType_1.EffectType.Bleeding) ? 70 : 0))
            ],
            onHit(sequence) {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new Bleeding_1.BleedingEffectArgs("Power", 10)
                    // TODO: VFX
                });
            }
        });
    }
};
AugurysFinalOmenAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.AugurysFinalOmen)
], AugurysFinalOmenAbilityHandler);
exports.AugurysFinalOmenAbilityHandler = AugurysFinalOmenAbilityHandler;
